import {useCallback, useRef, useState} from "react";

/** Хук, позволяющий считать параллельные асинхронные вызовы, чтобы можно было блокировать компоненты, пока есть хоть один незавершенный вызов */
export const useAsyncFieldValidator = () => {
  const [pendingCount, setPendingCount] = useState(0);
  const controllers = useRef(new Map()); // { fieldName -> AbortController }

  const runPromise = useCallback(async (fieldName, validatorFn) => {
    // отменяем предыдущий запрос для этого поля
    const prevController = controllers.current.get(fieldName);
    if (prevController) {
      prevController.abort();
    }

    const controller = new AbortController();
    controllers.current.set(fieldName, controller);

    setPendingCount((c) => c + 1);
    try {
      return await validatorFn(controller.signal);
    } catch (err) {
      if (err.name === "AbortError") {
        // отменён — игнорируем
        return undefined;
      }
      throw err;
    } finally {
      setPendingCount((c) => c - 1);
      // убираем контроллер, если он всё ещё актуален
      if (controllers.current.get(fieldName) === controller) {
        controllers.current.delete(fieldName);
      }
    }
  }, []);

  return {
    runPromise: runPromise,
    isLoading: pendingCount > 0
  };
};
